import React, { useState, Component, useEffect, useContext } from "react";
import Home from "./pages/home/Home";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./app.css";
import CreatePage from "./pages/create/CreatePage";
import Invoices from "./pages/invoices/Invoices";
import Login from "./pages/login/Login";
import AuthContext from "./context/AuthContext";
import jwt_decode from "jwt-decode";

import { getPieEntry, mergeSources, add, groupBy } from "./components/utils";

import PrivateRoute from "./utilty/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import Logout from "./pages/login/Logout";
import "./app.css";
import { ToastProvider } from "react-toast-notifications";
import { ConfirmProvider } from "material-ui-confirm";

const ProtectedRoute = () => {
  // console.log("in protected route component");
  // let { isAuthenticated, logoutUser } = useContext(AuthContext);
  // let redirectPath = "/login";

  // if (!isAuthenticated) {
  //   // console.log("not authenticated at protected route component");
  //   return <Navigate to={redirectPath} replace />;
  // }

  // useEffect(() => {

  //   // console.log("useffect in protected route component");
  //   let storageString = localStorage.getItem("authTokens");
  //   if (storageString) {
  //     let userToken = JSON.parse(storageString);
  //     let decodedToken = jwt_decode(userToken.access);
  //     let currentDate = new Date();
  //     if (decodedToken.exp * 1000 < currentDate.getTime()) {
  //       // console.log("logging out from protect route useffect ")
  //       logoutUser();
  //       return <Navigate to={redirectPath} replace />;
  //     }
  //   } else {
  //     return <Navigate to={redirectPath} replace />;
  //   }
  // });
  return <Outlet />;
};

const AdminRoute = () => {
  // console.log("in admin route component");
  let { isAuthenticated, isAdmin, logoutUser } = useContext(AuthContext);

  const navigate = useNavigate();
  let redirectPath = "/";

  useEffect(() => {
    // console.log("useffect in admin route component");
    // let storageString = localStorage.getItem("authTokens");
    // if (storageString) {
    //   let userToken = JSON.parse(storageString);
    //   let decodedToken = jwt_decode(userToken.access);
    //   let currentDate = new Date();
    //   if (decodedToken.exp * 1000 < currentDate.getTime()) {
    //     //token has expired
    //     // console.log("logging out from admin route useffect ")
    //     logoutUser();
    //     // return <Navigate to={redirectPath} replace />;
    //     navigate(redirectPath, { replace: true });
    //   }
    // }
    // // return <Navigate to={redirectPath} replace />;
    // navigate(redirectPath, { replace: true });
    //the brackets below is a weird effect, because datacontext will log out, we don't want a second logout to run
  }, []);

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  } else if (!isAdmin) {
    return <Navigate to={redirectPath} replace />;
  }
  return <Outlet />;
};

function App() {

  useEffect(() => {
    // console.log("useffect in app.js");
  }, []);
  // console.log("in app");

  //DONT DELETE
  // // const queryString = window.location.search;
  // const url = new URL(window.location.href);
  // // console.log(queryString);
  // if (url.searchParams.get('next')) {
  //   console.log(url.searchParams.get('next'))
  // }

  return (
    <BrowserRouter basename="/projects/staffingdashboard">
      <ToastProvider
        autoDismiss={true}
        placement={"bottom-left"}
        newestOnTop={true}
      >
        <AuthProvider>
          <DataProvider>
            <ConfirmProvider>
              <Routes>
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<Home />} />
                </Route>
                <Route element={<AdminRoute />}>
                  <Route path="create" element={<CreatePage />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route path="logout" element={<Logout />}></Route>
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route path="invoices" element={<Invoices />}></Route>
                </Route>
                <Route path="login" element={<Login />} />
              </Routes>
            </ConfirmProvider>
          </DataProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
